module.exports = __webpack_public_path__ + "assets/dutch.1a6be1ab.svg";